<template>
  <div class="card custom-panel">
    <header class="card-header">
      <p class="card-header-title has-text-weight-normal">Reassign Review:</p>
      <a @click.prevent="showHideReviewInfo" href="#" class="card-header-icon" aria-label="more options">
        <span class="icon">
          <i :class="[{ ' fa-minus': showInfo }, { 'fa-plus': !showInfo }, 'fas']" aria-hidden="true"></i>
        </span>
      </a>
    </header>
    <div v-if="showInfo" class="card-content has-text-weight-normal">
      <div class="control" :class="{ ' is-loading': is_loading, 'has-icons-right': org_selected }">
        <input class="input" type="text" :class="{ ' is-danger': org_selected && !business_available }"
          :name="`business_name`" v-model="form[`business_name`]" @keyup="orgLookup()"
          :placeholder="`Search for and select a business`" autocomplete="off" />

        <span class="search_icon">
          <i class="fa fa-search" aria-hidden="true"></i>
        </span>
        <!-- orgs lookup dropdown -->
        <div v-if="ajax_lookup">
          <div class="dropdown" :class="showOrgLookDropdown" v-show="orgsFound">
            <div class="dropdown-menu" role="menu">
              <div class="dropdown-content is-paddingless" @mouseleave.self="hideBusinessAutoComplete">
                <a v-for="business in businesses" @click.prevent="selectOrg(business)" href="#" :ref="`${business.id}`"
                  class="dropdown-item has-text-left">{{ business.name }}
                  <span v-if="business.subscription" class="icon is-right green" style=""><i
                      class="fas fa-check"></i></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-paddingless margin-top-20" v-if="form.business_name && form.business_id">
        <label v-if="reviewCount < 2" class="label is-size-7 break-words">
          <input type="checkbox" name="deleteProfileStatus" v-model="reassigned_checked" />
          &nbsp; Add {{ busniessDetails.name }} as an alias and delete profile
        </label>
        <label v-if="reviewCount < 2" class="label is-size-7 break-words">
          <input type="checkbox" name="deleteReassignedStatus" v-model="reassigned_delete_status" />
          &nbsp; Delete {{ busniessDetails.name }}
        </label>

        <div class="buttons">
          <span @click="saveReview" class="button is-button-grey-outline is-button-large">REASSIGN NOW</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef */
// import ReviewsWidgetMixin from './../mixins/reviews-widget.js';
import misc from './../mixins/misc.js'
import ApiResource from './../api/ApiResource'
import axios from 'axios'

export default {
  name: 'ReassignReview',
  mixins: [misc],
  data () {
    return {
      showInfo: true,
      is_loading: false,
      show_dropdown: false,
      org_selected: false,
      business_available: false,
      on_blur_close: false,
      ajax_lookup: true,
      drop_down_opened: false,
      businesses: [],
      delete_reassigned_checked: true,
      reassigned_delete_status: false,
      reassigned_checked: false,
      checkTextStatus: false,
      businessSlug: '',
      reviewPermalink: '',
      busniessDetails: {},
      form: new ApiResource({
        business_id: '',
        business_name: ''
      })
    }
  },
  props: {
    name: String,
    reviewPermalinkParam: String,
    reviewSlugParam: String,
    reportedReviewPage: Boolean,
    reviewBizDetailData: Object,
    reportReviewBizDetailData: Object,
    reviewAuthorData: Object,
    reviewCount: Number
  },
  components: {},
  computed: {
    isBusinessAvailable () {
      return this.business_available
    },
    showOrgLookDropdown () {
      if (this.on_blur_close && !this.org_selected) {
        return ''
      }
      if ((this.org_selected || this.orgsFound) && !this.on_blur_close) {
        return 'is-active'
      }
    },
    orgsFound () {
      return this.businesses.length > 0
    }
  },
  watch: {
    form: {
      handler: function (formVal) {
        if (formVal.business_name.length === 0) {
          this.can_submit = false
          this.business_available = false
        }
      }
    }
  },
  methods: {
    // submit review reassign
    saveReview () {
      this.is_loading = true
      let params = {
        business_slug: this.form.business_slug,
        business_id: this.form.business_id,
        checked_status: this.reassigned_checked,
        reassignedDeleteStatus: this.reassigned_delete_status,
        reviewPermalink: this.reviewPermalink,
        reportedReviewID: this.reportReviewBizDetailData.reportId,
        reportSlug: this.reviewSlugParam
      }
      const businessSlug = this.businessSlug
      new ApiResource({})
        .send(`/${businessSlug}/reviews/reassign`, params, 'post')
        .then(data => {
          const uniqueInd = new Set([
            data.industry.slug,
            this.busniessDetails.industry.slug
          ])
          this.recacheOnReviewTouched(
            [...uniqueInd],
            [this.form.business_slug, this.businessSlug],
            [
              {
                bizSlug: this.form.business_slug,
                permalink: this.reviewPermalink
              },
              { bizSlug: this.businessSlug, permalink: this.reviewPermalink }
            ]
          )
          window.events.$emit('addReassignReviews', this.form.business_slug)
          this.is_loading = false
          flash(
            `Review has been successfully reassigned to ` +
            this.asText(this.form.business_name, 80),
            'is-success'
          )
          this.busniessDetails.name = this.form.business_name
          this.form.business_id = ''
          this.form.business_name = ''
          this.refreshData(this.form.business_slug)
          if (this.reportedReviewPage) {
            this.$router.push(
              `/reported-review/${this.form.business_slug}/${this.reviewPermalink}/${this.reviewSlugParam}/${this.reportReviewBizDetailData.reportId}/${this.reportReviewBizDetailData.reviewId}`
            )
          } else {
            this.$router.push(
              `/business/${this.form.business_slug}/review/${this.reviewPermalink}/${this.reviewBizDetailData.reviewId}`
            )
          }
        })
        .catch(error => {
          this.is_loading = false
          if (error.error) {
            flash(error.error, `is-danger`)
          } else {
            flash(
              `There was an error reassigning this review. Please try again.`,
              `is-danger`
            )
          }
        })
    },
    closeOrgLookup () {
      this.on_blur_close = true
      if (this.drop_down_opened) {
        this.hideBusinessAutoComplete()
      }
    },
    hasIconRight (element) {
      return element.ajax_lookup !== undefined && element.ajax_lookup
    },
    orgLookup () {
      if (this.form.business_name) {
        this.checkTextStatus = true
      }
      this.org_selected = false
      this.show_dropdown = false
      this.form.business_id = ''
      this.on_blur_close = false
      if (this.form.business_name.length < 3) {
        this.businesses = []
        this.show_dropdown = false
      } else {
        this.is_loading = true
        let keyword = encodeURIComponent(this.form.business_name)
        new ApiResource({})
          .send(`/search/business?name=${keyword}`, {}, 'get')
          .then(businesses => {
            if (businesses.length === 0) {
              this.businesses = []
              this.org_selected = true
              this.show_dropdown = false
              this.business_available = true
              this.drop_down_opened = false
              this.is_loading = false
              closeFlash()
            } else {
              this.drop_down_opened = true
              this.businesses = businesses
              this.is_loading = false
            }
          })
          .catch(() => {
            flash(
              `Error retrieving possible businesses! Contact the System's Administrator.`,
              `is-danger`
            )
            this.is_loading = false
            this.drop_down_opened = false
          })
      }
    },
    /**
     * On click listener for when user selects a business from list of suggestions presented from api
     * @returns {null}
     * @param {business} business selected by user
     */
    selectOrg (business) {
      this.org_selected = true
      this.form.business_name = business.name
      this.form.business_slug = business.slug
      this.form.business_id = business.id
      this.form.status = business.status
      this.businesses = []

      this.business_available = true
      closeFlash()
      this.drop_down_opened = false
    },
    showDropdown () {
      this.show_dropdown = !this.show_dropdown
    },
    hideDropdown () {
      this.show_dropdown = false
    },
    hideBusinessAutoComplete () {
      try {
        this.drop_down_opened = true
        this.on_blur_close = true
        const parent = this
        parent.business_available = false
        this.businesses.forEach(business => {
          let inlist = false
          if (
            this.form.business_name.toLowerCase() ===
            business.name.toLowerCase() &&
            !inlist
          ) {
            if (business.status !== 'ACTIVE' && !inlist) {
              inlist = true
              parent.org_selected = true
              parent.business_available = true
              parent.drop_down_opened = false
              closeFlash()
              throw new Exception('available')
            }
          }
          if (
            this.form.business_name.toLowerCase() !==
            business.name.toLowerCase() &&
            !inlist
          ) {
            inlist = true
            parent.business_available = true
            parent.drop_down_opened = false
            parent.org_selected = true
            closeFlash()
          }
        })
      } catch (e) { }
    },
    Exception (error) {
      console.log(error)
    },
    // get current business details
    getCurrentBusinessDetails () {
      axios
        .get(`/business/${this.businessSlug}`)
        .then(response => {
          this.busniessDetails = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    refreshData (businessSlug) {
      this.businessSlug = businessSlug
      this.getCurrentBusinessDetails()
    }
  },
  created () {
    let bizSlug = this.$route.params.businessSlug
    if (!bizSlug) {
      bizSlug = this.$route.params.businessSlugFromProp
    }
    this.refreshData(bizSlug)
    this.reviewPermalink = this.$route.params.reviewPermalink
    if (this.reviewPermalinkParam) {
      this.reviewPermalink = this.reviewPermalinkParam
    }
  }
}
</script>

<style scoped>
.dropdown-trigger {
  text-align: left;
  width: 100%;
}

.dropdown {
  display: block;
  width: 100%;
}

.dropdown-menu {
  border-top: 3px solid #30aae1;
  width: 100%;
  padding-top: 0 !important;
  border-bottom: 1px solid #e1dfdf;
}

a.dropdown-item:hover {
  background-color: #30aae1;
  color: #fff;
}

.dropdown-content {
  border-radius: 0;
  overflow-y: scroll;
  height: 200px;
}

.dropdown-item {
  padding: 10px !important;
  border-color: #dbdbdb;
  border: 1px solid transparent;
}

.button-dropdown {
  text-align: left;
}

/* search field icon */
.column.is-paddingless.margin-top-20 {
  text-align: right;
}

.label.is-size-7 {
  font-weight: 500;
  text-align: left;
}

.card-content .input {
  padding-left: 25px;
}

.search_icon {
  position: absolute;
  left: 5px;
  top: 5px;
  z-index: 1;
  color: darkgray;
}

.buttons {
  display: flex;
  justify-content: flex-end;
}

.icon.green {
  color: #16be85 !important;
}

.break-words {
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/widgets/ReassignReviewWidget.vue